export default __webpack_public_path__ + "static/maybankFoundation-1a455a153af03232f66d50cbbbd2fee7.png";